import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { bool, func, string } from 'prop-types';
import { useLocation, useParams } from 'react-router';

import OpportunityDetails from '../OpportunityDetails/OpportunityDetails';
import { getDecoratedOpportunity } from '../../redux/actions/opportunities';
import { TalentProfile } from '../TalentProfile/TalentProfile';
import { formatDataTestId } from '../../utils/data-test-util';

export const SideDrawerContents = ({
  name,
  openDrawer,
  closeDrawer,
  expanded,
}) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { pathname } = useLocation();

  const isTalentView =
    pathname.startsWith('/talent') || pathname.startsWith('/bench');
  const isOpportunityView =
    pathname.startsWith('/opp') || pathname.startsWith('/workspace/opp');

  useEffect(() => {
    openDrawer();
    if (isOpportunityView) {
      dispatch(getDecoratedOpportunity(id));
    }
  }, [id]);

  return (
    <>
      {!!isTalentView && (
        <TalentProfile
          expanded={expanded}
          onCloseSidedrawer={closeDrawer}
          candidateId={id}
        />
      )}
      {!!isOpportunityView && (
        <OpportunityDetails
          expanded={expanded}
          onCloseSidedrawer={closeDrawer}
        />
      )}
      {!id && (
        <p data-teat={formatDataTestId('no side drawer content')}>
          Please select a record from the list.
        </p>
      )}
    </>
  );
};

SideDrawerContents.propTypes = {
  closeDrawer: func.isRequired,
  expanded: bool.isRequired,
  name: string,
  openDrawer: func.isRequired,
};
